package com.dotdrives.web.pages.givers

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

private val giversStyles = """
    .givers-page { min-height: calc(100vh - 118px); }
    .givers-controls {
      display: flex; align-items: center; gap: 10px; margin-bottom: 16px;
    }
    .givers-search {
      width: 230px; min-height: 38px; padding: 8px 14px; border: 1px solid transparent;
      border-radius: 99px; outline: none; color: #222D32; background: white; font-size: 13px;
    }
    .givers-search:focus { border-color: #F26223; box-shadow: 0 0 0 2px #FDE5DA; }
    .givers-filter {
      min-height: 32px; padding: 5px 12px; border: 1.5px solid #D6DBE0; border-radius: 99px;
      color: #5A6870; background: white; cursor: pointer; font-size: 12px; font-weight: 800;
    }
    .givers-filter-active { border-color: #F26223; color: var(--dot-action-text); background: #FDE5DA; }
    select.givers-filter { appearance: auto; }
    .givers-table-head, .givers-table-row {
      display: grid; grid-template-columns: 2fr 1.25fr .8fr .9fr 1fr; gap: 14px; align-items: center;
    }
    .givers-table-head {
      padding: 0 14px 8px; color: var(--dot-muted); font-family: 'IBM Plex Mono', monospace;
      font-size: 10.5px; font-weight: 500; letter-spacing: .7px;
    }
    .givers-table-body { display: flex; flex-direction: column; gap: 8px; }
    .givers-table-row {
      width: 100%; padding: 12px 14px; border: 1px solid #E4E8EC; border-radius: 12px;
      color: #222D32; background: white; cursor: pointer; text-align: left;
      transition: border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease;
    }
    .givers-table-row:hover { border-color: #F26223; background: #FEF8F6; box-shadow: 0 4px 14px rgba(34,45,50,.08); }
    .givers-table-row:focus-visible, .givers-filter:focus-visible, .givers-page button:focus-visible,
    .givers-dialog input:focus-visible, .givers-dialog select:focus-visible, .givers-dialog textarea:focus-visible {
      outline: 2px solid var(--dot-focus); outline-offset: 2px;
    }
    .givers-person { min-width: 0; display: flex; align-items: center; gap: 11px; }
    .givers-avatar {
      width: 36px; height: 36px; display: flex; flex: 0 0 auto; align-items: center; justify-content: center;
      border-radius: 50%; color: white; background: #4696EC; font-size: 12px; font-weight: 800;
    }
    .givers-person-copy { min-width: 0; }
    .givers-person-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 14px; font-weight: 800; }
    .givers-person-meta { margin-top: 1px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--dot-muted); font-size: 11.5px; }
    .givers-steward { color: #3D4A52; font-size: 13px; font-weight: 700; }
    .givers-money { font-family: 'IBM Plex Mono', monospace; font-size: 12.5px; font-weight: 500; }
    .givers-tags { min-width: 0; display: flex; flex-wrap: wrap; gap: 4px; }
    .givers-tag { min-height: 22px; padding: 2px 8px; font-size: 10.5px; }
    .givers-pagination { display: flex; justify-content: center; gap: 4px; margin-top: 16px; }
    .givers-page-button {
      min-width: 34px; height: 32px; border-radius: 8px; color: var(--dot-muted); background: transparent;
      cursor: pointer; font-size: 13px; font-weight: 800;
    }
    .givers-page-button:hover:not(:disabled) { color: var(--dot-action-text); background: #FDE5DA; }
    .givers-page-button-active { color: white; background: var(--dot-action); }
    .givers-page-button:disabled { cursor: default; opacity: .4; }
    .givers-ellipsis { min-width: 28px; display: grid; place-items: center; color: var(--dot-muted); }
    .givers-empty {
      min-height: 430px; display: grid; place-items: center; padding: 44px; text-align: center;
      border: 1px dashed #D6DBE0; border-radius: 16px; background: rgba(255,255,255,.42);
    }
    .givers-empty-emoji { font-size: 44px; }
    .givers-empty-title { margin-top: 12px; font-family: 'Quicksand', sans-serif; font-size: 21px; font-weight: 700; }
    .givers-empty-copy { max-width: 390px; margin: 8px auto 20px; color: #5A6870; font-size: 14px; line-height: 1.65; }
    .givers-empty-actions { display: flex; justify-content: center; gap: 10px; }
    .givers-topbar-button { min-height: 38px; padding: 8px 15px; font-size: 13px; }
    .givers-count {
      margin-left: 7px; color: var(--dot-muted); font-family: 'IBM Plex Mono', monospace;
      font-size: 13px; font-weight: 400;
    }
    .givers-backdrop {
      position: fixed; z-index: 30; inset: 0; display: flex; justify-content: flex-end;
      background: rgba(34,45,50,.34); animation: givers-fade-in 180ms ease both;
    }
    .givers-drawer {
      width: min(440px, 94vw); height: 100%; display: flex; flex-direction: column; overflow: hidden;
      border-left: 1px solid #E4E8EC; background: white; box-shadow: -16px 0 44px rgba(34,45,50,.16);
      animation: givers-drawer-in 300ms cubic-bezier(.22,1,.36,1) both;
    }
    .givers-drawer-head { padding: 22px 24px; border-bottom: 1px solid #E4E8EC; color: #222D32; background: white; }
    .givers-drawer-person { display: flex; align-items: center; gap: 14px; }
    .givers-drawer-avatar { width: 52px; height: 52px; font-size: 18px; }
    .givers-drawer-name { font-family: 'Quicksand', sans-serif; font-size: 19px; font-weight: 700; }
    .givers-drawer-meta { margin-top: 2px; color: #5A6870; font-size: 12.5px; }
    .givers-drawer-close {
      margin-left: auto; align-self: flex-start; color: var(--dot-muted); background: transparent;
      cursor: pointer; font-size: 18px;
    }
    .givers-drawer-actions { display: flex; gap: 8px; margin-top: 16px; }
    .givers-action-pill {
      padding: 7px 14px; border: 1px solid #E4E8EC; border-radius: 99px;
      color: #5A6870; background: #EFF1F4;
      cursor: pointer; font-size: 12px; font-weight: 800;
    }
    .givers-action-pill:hover:not(:disabled) { border-color: #F26223; color: var(--dot-action-text); background: #FDE5DA; }
    .givers-drawer-actions > span:first-child .givers-action-pill {
      border-color: #FDE5DA; color: var(--dot-action-text); background: #FDE5DA;
    }
    .givers-action-pill:disabled { cursor: not-allowed; opacity: .7; }
    .givers-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: 16px; }
    .givers-stat { padding: 10px 12px; border: 1px solid #E4E8EC; border-radius: 10px; background: #F7F8FA; }
    .givers-stat-label { color: var(--dot-muted); font-family: 'IBM Plex Mono', monospace; font-size: 9.5px; letter-spacing: 1px; }
    .givers-stat-value { margin-top: 3px; font-family: 'IBM Plex Mono', monospace; font-size: 15px; font-weight: 500; }
    .givers-drawer-tabs { display: flex; overflow-x:auto; flex-shrink:0; padding: 0 18px; border-bottom: 1px solid #E4E8EC; background: white; }
    .givers-tab {
      padding: 12px 10px 9px; border-bottom: 3px solid transparent; color: var(--dot-muted);
      background: transparent; cursor: pointer; font-size: 12.5px; font-weight: 800;
    }
    .givers-tab-active { border-color: #F26223; color: #222D32; }
    .givers-drawer-body { min-height: 0; flex: 1; overflow: auto; padding: 18px 22px 24px; }
    .givers-inline-banner { margin-bottom: 12px; }
    .givers-timeline-filters { display: flex; gap: 6px; margin-bottom: 14px; }
    .givers-timeline { position: relative; display: flex; flex-direction: column; gap: 12px; padding-left: 25px; }
    .givers-timeline::before { content: ''; position: absolute; left: 8px; top: 8px; bottom: 8px; width: 2px; background: #EFF1F4; }
    .givers-timeline-item { position: relative; padding: 13px 15px; border: 1px solid #E4E8EC; border-radius: 12px; background: white; }
    .givers-timeline-dot {
      position: absolute; left: -25px; top: 17px; width: 16px; height: 16px; display: grid; place-items: center;
      border: 3px solid white; border-radius: 50%; background: #4696EC; box-shadow: 0 0 0 2px #4696EC;
      font-size: 7px;
    }
    .givers-timeline-title-row { display: flex; justify-content: space-between; gap: 12px; }
    .givers-timeline-title { font-size: 13px; font-weight: 800; }
    .givers-timeline-date { flex: 0 0 auto; color: var(--dot-muted); font-family: 'IBM Plex Mono', monospace; font-size: 9.5px; }
    .givers-timeline-meta { display: flex; flex: 0 0 auto; align-items: flex-end; gap: 5px; flex-direction: column; }
    .givers-timeline-tone { min-height: 20px; padding: 1px 7px; font-size: 9.5px; line-height: 16px; }
    .givers-timeline-body { margin-top: 5px; color: #5A6870; font-size: 12.5px; line-height: 1.5; }
    .givers-note-card { margin-bottom: 10px; padding: 13px 15px; border: 1px solid #E4E8EC; border-radius: 12px; }
    .givers-note-title-row { display: flex; justify-content: space-between; gap: 10px; }
    .givers-note-title { font-size: 13px; font-weight: 800; }
    .givers-note-body { margin-top: 5px; color: #5A6870; font-size: 12.5px; line-height: 1.55; white-space: pre-wrap; }
    .givers-composer { display: grid; gap: 9px; margin-top: 16px; padding-top: 16px; border-top: 1px solid #E4E8EC; }
    .givers-composer-title { font-family: 'Quicksand', sans-serif; font-size: 15px; font-weight: 700; }
    .givers-composer input, .givers-composer textarea, .givers-dialog input, .givers-dialog select {
      width: 100%; padding: 10px 12px; border: 1px solid #E4E8EC; border-radius: 10px;
      outline: none; color: #222D32; background: white; font-size: 13px;
    }
    .givers-composer textarea { min-height: 88px; resize: vertical; }
    .givers-composer-actions { display: flex; justify-content: flex-end; }
    .givers-dialog-backdrop { align-items: center; justify-content: center; padding: 24px; }
    .givers-dialog {
      width: min(560px, 100%); max-height: calc(100vh - 48px); overflow: auto; padding: 26px 30px;
      border-radius: 20px; background: white; box-shadow: 0 24px 80px rgba(34,45,50,.25);
      animation: givers-pop-in 220ms ease both;
    }
    .givers-dialog-head { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 16px; }
    .givers-dialog-title { font-family: 'Quicksand', sans-serif; font-size: 20px; font-weight: 700; }
    .givers-type-toggle { display: flex; padding: 3px; border-radius: 99px; background: #EFF1F4; }
    .givers-type-option {
      padding: 6px 13px; border-radius: 99px; color: var(--dot-muted); background: transparent;
      cursor: pointer; font-size: 12px; font-weight: 800;
    }
    .givers-type-option-active { color: #222D32; background: white; box-shadow: 0 1px 4px rgba(34,45,50,.12); }
    .givers-form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin-bottom: 10px; }
    .givers-form-field { display: grid; gap: 5px; }
    .givers-form-field-full { margin-bottom: 10px; }
    .givers-form-label { font-size: 12px; font-weight: 800; }
    .givers-tags-input { display: flex; gap: 6px; }
    .givers-tags-input input { min-width: 0; flex: 1; }
    .givers-add-tag {
      flex: 0 0 auto; padding: 0 11px; border-radius: 10px; color: var(--dot-action-text); background: #FDE5DA;
      cursor: pointer; font-weight: 800;
    }
    .givers-dialog-tags { display: flex; flex-wrap: wrap; gap: 5px; margin-top: 7px; }
    .givers-remove-tag { cursor: pointer; }
    .givers-dialog-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 18px; }
    .givers-drawer-loading { display: grid; gap: 12px; padding: 22px; }

    .portal-shell .ns-dialog-backdrop { z-index:100; }
    .givers-dialog-backdrop { z-index:100; }
    .givers-year-total {font-size:10px;color:#5A6870;margin-top:4px;}
    .givers-no-finance {grid-template-columns:minmax(220px,1.6fr) 1fr 1fr;}
    .givers-drawer-head { background:#222D32; color:white; border:0; }
    .givers-drawer-meta { color:#B6C2C9; }
    .givers-drawer-close { color:#C9D3D9; }
    .givers-stat { background:#ffffff10; border:0; }
    .givers-stat-label { color:#B6C2C9; }
    .givers-stat-value { color:#F79E78; }
    .givers-drawer-actions .givers-action-pill { background:#ffffff14; border-color:#ffffff25; color:white; }
    .givers-drawer-actions .givers-action-pill:first-child { background:var(--dot-action); color:white; border-color:#F26223; }
    .givers-tab { color:#5A6870; }
    .giver-experience-row,.giver-statement-row { display:flex;align-items:center;justify-content:space-between;gap:15px;padding:16px 0;border-bottom:1px solid #E4E8EC;font-size:13px; }
    .giver-experience-row strong { font:500 15px 'IBM Plex Mono'; }
    .giver-experience-row p,.giver-statement-row p { margin:4px 0;color:#5A6870;font-size:12px; }
    .giver-experience-row small,.giver-statement-row small { display:block;color:#5A6870;font-size:11px;margin-top:4px; }
    .giver-experience-row button,.giver-statement-actions button,.giver-statement-request button,.giver-download-link,.giver-file-picker { border:1px solid #E4E8EC;background:white;color: var(--dot-action-text);border-radius:99px;padding:8px 12px;font:800 12px 'Nunito Sans';cursor:pointer; }
    .giver-statement-actions {display:flex;gap:6px;flex-wrap:wrap;justify-content:flex-end; }
    .giver-experience-meta {font-size:12px;line-height:1.6;color:#5A6870; }
    .giver-statement-request {display:flex;gap:8px;margin:16px 0; }
    .giver-statement-request select {padding:8px;border:1px solid #E4E8EC;border-radius:9px; }
    .giver-experience-message {background:#E3F1E8;color:#007942;padding:10px;border-radius:10px;font-size:12px;line-height:1.5; }
    .giver-file-picker {display:block;position:relative;overflow:hidden;background:#FDE5DA;border-color:#FDE5DA;width:fit-content; }
    .giver-file-picker input {position:absolute;inset:0;opacity:0;cursor:pointer;width:100%; }
    .giver-file-picker:focus-within {outline:3px solid #4696EC; }
    .giver-download-link {display:inline-block;margin:10px 0;background:#FDE5DA; }
    @media(max-width:700px){.givers-backdrop {z-index:80}.givers-drawer {width:100vw;border:0}.givers-drawer-head {padding:18px 20px}.givers-drawer-tabs {padding:0 12px}.givers-tab {flex:0 0 auto;padding-inline:12px}.givers-drawer-body {padding:16px}.givers-stats {gap:5px}.giver-statement-row {align-items:flex-start}.giver-statement-actions {flex-direction:column}.givers-dialog-actions {flex-wrap:wrap}}
    @keyframes givers-drawer-in { from { transform: translateX(40px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
    @keyframes givers-pop-in { from { transform: translateY(14px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
    @keyframes givers-fade-in { from { opacity: 0; } to { opacity: 1; } }
    @media (max-width: 900px) {
      .givers-table-head { display: none; }
      .givers-table-row { grid-template-columns: 1fr auto; }
      .givers-table-row > :nth-child(2), .givers-table-row > :nth-child(5) { display: none; }
      .givers-controls { flex-wrap: wrap; }
      .givers-search { width: 100%; }
    }
    @media (max-width: 620px) {
      .givers-page { min-height: calc(100vh - 88px); }
      .givers-empty { padding: 28px 16px; }
      .givers-empty-actions, .givers-dialog-actions { flex-direction: column; }
      .givers-form-grid { grid-template-columns: 1fr; }
      .givers-dialog { padding: 22px 18px; }
      .givers-dialog-head { align-items: flex-start; flex-direction: column; }
      .givers-stats { gap: 5px; }
      .givers-stat { padding-inline: 8px; }
    }
""".trimIndent()

val GiversStyles = FC<Props> {
    style { +giversStyles }
}
